/**
 * 환경별로 data-testid를 조건부로 추가하는 유틸리티
 */
import { isAppDebugEnabled } from '@/utils/debug/debugEnv';

export const isTestEnvironment = () => {
  return isAppDebugEnabled() || process.env.CYPRESS_TESTING === 'true';
};

export const getTestId = (testId) => {
  return isTestEnvironment() ? testId : null;
};

// Vue 컴포넌트에서 사용할 수 있는 믹스인
export const testIdMixin = {
  methods: {
    getTestId(testId) {
      return getTestId(testId);
    }
  }
};

// 컴포넌트에서 사용 예시
export const createTestId = (baseId, suffix = '') => {
  const fullId = suffix ? `${baseId}-${suffix}` : baseId;
  return getTestId(fullId);
};

// 프로덕션에서 data-testid 숨기기 위한 CSS 클래스
export const getTestIdClass = () => {
  return isTestEnvironment() ? 'test-visible' : 'test-hidden';
};

// 현재 환경 정보 출력 (디버깅용)
export const getEnvironmentInfo = () => {
  return {
    NODE_ENV: process.env.NODE_ENV,
    CYPRESS_TESTING: process.env.CYPRESS_TESTING,
    isTestEnvironment: isTestEnvironment()
  };
};
